import { PlannerMemo }   from "../../planner_base";
class Cell extends PlannerMemo {
  init(){
    super.init();
    this.watch();
  }
}
riot.mixin('orders.planner.schedules.cell', Cell as riot.TagMixin)
